'use client'

import { FC } from 'react'
import { ChargesTableProps } from '@/root/shared-types'
import { TicketPartProps } from '@/root/shared-types/reservation/reservation-types'
import { RouteCard } from '@/root/modules/tuuleliinid/BookTicket/components/RouteCard/RouteCard'
import { ChargesSummary } from '@/root/modules/tuuleliinid/BookTicket/components/ChargesSummary/ChargesSummary'
import { Divider } from '@/root/ui/tuuleliinid'
import { useGetTranslations } from '@/root/shared-hooks'

interface ShoppingCartProps {
  there: TicketPartProps
  back?: TicketPartProps
  isRoundTrip: boolean
  chargesTable: ChargesTableProps
  totalText: string
  totalAmount: string
  columns: string[]
  onEdit?: () => void
}

export const ShoppingCart: FC<ShoppingCartProps> = ({
  there,
  back,
  isRoundTrip,
  chargesTable,
  totalText,
  totalAmount,
  columns,
  onEdit,
}) => {
  const { getTranslation } = useGetTranslations()

  return (
    <div className="flex w-full flex-col items-start gap-5 rounded-2xl bg-white p-5 lg:gap-8">
      {/* Title */}
      <h2 className="w-full text-center text-2xl leading-tight font-bold">
        {getTranslation('selectedTicketsCartTitle')}
      </h2>

      {/* Content */}
      <div className="flex w-full flex-col gap-5">
        {/* There route */}
        <RouteCard
          routeName={`${there.departurePort} - ${there.arrivalPort}`}
          departurePort={there.departurePort}
          arrivalPort={there.arrivalPort}
          departure={there.departure || ''}
          vesselTitle={there.vesselTitle}
          items={there.items}
          residents={there.residents}
          columns={columns}
          onEdit={onEdit}
        />
        {/* Round-trip divider and back route */}
        {isRoundTrip && back && (
          <>
            <Divider />
            <RouteCard
              routeName={`${back.departurePort} - ${back.arrivalPort}`}
              departurePort={back.departurePort}
              arrivalPort={back.arrivalPort}
              departure={back.departure || ''}
              vesselTitle={back.vesselTitle}
              items={back.items}
              residents={back.residents}
              columns={columns}
              onEdit={onEdit}
            />
          </>
        )}
        {/* Charge summary */}
        <ChargesSummary chargesTable={chargesTable} />
        {/* Divider before total */}
        <div className="w-full py-1.5">
          <div className="border-primary-base w-full border-t" />
        </div>
        {/* Total */}
        <div className="flex w-full items-center justify-center gap-5 pb-2.5 text-xl font-bold">
          <span className="">{totalText}:</span>
          <span className="text-right">{totalAmount}</span>
        </div>
      </div>
    </div>
  )
}
